import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="course-material-app-initiator"
export default class extends Controller {
  connect() {
    this.wait_for_assets(() => {
      window.initCourseMaterialApp()
    });
  }

  wait_for_assets(callback) {
    const check = () => {
      if (window.initCourseMaterialApp && document.getElementById('course-material-app-vue-app')) {
        callback();
      } else {
        requestAnimationFrame(check); // try again on the next frame
      }
    };
    check();
  }
}
